export default __webpack_public_path__ + "static/media/anipreview.1fbd3584.webp";